'use strict';

/**
* Кнопка панели действий.
* 
* @class WebAccess.components.wrappers.toolBar.ToolBarButton
* @extends WebAccess.components.wrappers.BasePageElement
* @property {string} name Имя кнопки
* @property {group} groupName Группа, в которой находится кнопка
* @property {string} selector Путь в DOM-иерархии к объекту кнопки, например div.content#container   
* @property {boolean} isSynthetic Признак, указывающий на то, что кнопка была создана средствами API
* @param {string} itemSelector Существующий элемент страницы
*/

(function (global) {

  var buttonSelector = "div.toolbar_button";
  var groupSelector = "div.toolbar_group";

  // Признак доступности действия, если в области вложений выделен хотя бы один элемент.
  var isEnabledOnAttachmentSelected = 1 << 0;

  // Признак доступности действия, если ЗЗУ прекращено.
  var isEnabledOnAborted = 1 << 1;

  // Признак доступности действия, если ЗЗУ выполнено.
  var isEnabledOnDone = 1 << 2;

  // Признак доступности действия, если ЗЗУ в работе.
  var isEnabledOnRunning = 1 << 3;

  var ToolBarButton = global.components.wrappers.BasePageElement.extend({
    init: function (itemSelector) {
      this._super(itemSelector);
      this.selector = format(this._byNameSelectorTemplate, buttonSelector, this.name);
      this.groupName = this._jObject.parents(groupSelector).attr("name");
      this._jGroup = this._jObject.parents(groupSelector);

      // Установка свойства связанного прикладного действия
      this._linkedAction = this._jObject.data('linkedaction');
      this._enabledMode = this._jObject.data('enabledmode');
      var enabledWhen = this._jObject.data('enabledwhen');
      if (enabledWhen) {
        this._enabledWhen = enabledWhen;
      }
      let contentsActionEnableMode = this._jObject.data('contentsactionenablemode');
      if (contentsActionEnableMode){
        this._contentsActionEnableMode = contentsActionEnableMode;
      }

      // Получить тексты всплывающих подсказок
      this._disabledHint = this._jObject.data('disabledhint');
      this._hint = this._jObject.data('hint');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    className: 'ToolBarButton',
    groupName: '',
    isSynthetic: false,
    _jGroup: null,
    _inlineEvent: '',
    _linkedAction: null,
    _enabledMode: null,
    _disabledHint: '',
    _hint: '',
    _enabledWhen: null,
    _contentsActionEnableMode: 0,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Изменяет размер кнопки.
     * Размер кнопки регулируется отображением и скрытием ее заголовка.
     *
     * @deprecated since 5.6. Используйте методы hideCaption и showCaption.
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#convertTo
     * @param {BUTTON} buttonType Тип кнопки
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
     * @since 5.0.0.4104
     */
    convertTo(buttonType) {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return (buttonType === BUTTON.LARGE) ? this.showCaption() : this.hideCaption();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
     * Скрывает заголовок кнопки.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#hideCaption
     * @since 5.6.0.1300
     */
    hideCaption() {
      if (this.isCaptionVisible()) {
        this._jObject.removeClass('toolbar_item').addClass('small_toolbar_item');
      }
      return this;
    },

    /**
     * Отображает заголовок кнопки.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#showCaption
     * @since 5.6.0.1300
     */
    showCaption() {
      if (!this.isCaptionVisible()) {
        this._jObject.removeClass('small_toolbar_item').addClass('toolbar_item');
      }
      return this;
    },

    /**
    * Получает имя прикладного действия, связанного с кнопкой на панели действий.
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getLinkedAction
    * @return {string} Имя прикладного действия, если действие указано, иначе пустая строка.
    */
    getLinkedAction() {
      return this._linkedAction;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает режим доступности кнопки.
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getEnabledMode
	* @return {ACTION_ENABLED_MODE} Режим доступности кнопки.
    */
    getEnabledMode() {
      return this._enabledMode;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает режим доступности кнопки, если в области вложений выделен хотя бы один элемент.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnAttachnentSelected
     * @deprecated since 5.6. Use getIsEnabledOnAttachmentSelected instead.
     * @returns {boolean} True - если кнопка доступна, иначе False.
     */
    getIsEnabledOnAttachnentSelected() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return this.getIsEnabledOnAttachmentSelected();
    },

    /**
     * Получает режим доступности кнопки, если в области вложений выделен хотя бы один элемент.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnAttachmentSelected
     * @return {boolean} True - кнопка доступна, иначе False.
     */
    getIsEnabledOnAttachmentSelected() {
      if (this._enabledWhen) {
        return Boolean(this._enabledWhen & isEnabledOnAttachmentSelected);
      }
      return false;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает режим доступности кнопки для состояния "Прекращено".
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnAborted
    * @return {boolean} True - кнопка доступна, иначе False.
    */
    getIsEnabledOnAborted() {
      if (this._enabledWhen) {
        return Boolean(this._enabledWhen & isEnabledOnAborted);
      }
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает режим доступности кнопки для состояния "Выполнено".
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnDone
    * @return {boolean} True - кнопка доступна, иначе False.
    */
    getIsEnabledOnDone() {
      if (this._enabledWhen) {
        return Boolean(this._enabledWhen & isEnabledOnDone);
      }
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает режим доступности кнопки для состояния "В работе".
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnRunning
    * @return {boolean} True - кнопка доступна, иначе False.
    */
    getIsEnabledOnRunning() {
      if (this._enabledWhen) {
        return Boolean(this._enabledWhen & isEnabledOnRunning);
      }
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Признак того, что кнопка нажата.
    * Получает режим доступности кнопки только для выделенных записей.
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledOnlyForSelected
    * @return {boolean} True - кнопка доступна, иначе False.
    */
    getIsEnabledOnlyForSelected() {
      return Boolean(this._contentsActionEnableMode & CONTENTS_ACTION_ENABLED_MODE.ENABLED_ONLY_FOR_SELECTED);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает режим доступности кнопки при множественном выборе.
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getIsEnabledWhenMultiSelect
    * @return {boolean} True - кнопка доступна, иначе False.
    */
    getIsEnabledWhenMultiSelect() {
      return Boolean(this._contentsActionEnableMode & CONTENTS_ACTION_ENABLED_MODE.ENABLED_WHEN_MULTISELECT);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Признак того, что кнопка нажата.
    *
    * @method WebAccess.components.wrappers.toolBar.ToolBarButton#isSelected
    * @return {boolean} True, если кнопка нажата, иначе False.
    * @since 5.3.0.1104
    */
    isSelected() {
      return this._jObject.hasClass("selected");
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Признак кнопки маленького размера.
     *
     * @deprecated since 5.6. Используйте метод isCaptionVisible.
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#isSmall
     * @returns {boolean} TRUE, если кнопка уменьшена (у кнопки не отображается название), иначе - FALSE.
     * @since 5.0.0.4104
     */
    isSmall() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return !this.isCaptionVisible();
    },

    /**
     * Признак видимости названия кнопки.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#isCaptionVisible
     * @returns {boolean} TRUE, если у кнопки отображается название, иначе - FALSE.
     * @since 5.6.0.9072
     */
    isCaptionVisible() {
      return !this._jObject.hasClass('small_toolbar_item');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает родительскую группу кнопок.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#getParentGroup
     * @returns {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа WebAccess.components.wrappers.toolBar.ToolBarGroup.
     * @since 5.6.0.1300
     */
    getParentGroup() {
      this.groupName = this._jObject.parents(groupSelector).attr("name");
      return global.current.toolBar.groups[this.groupName];
    },

    /**
     * Получает родительскую группу кнопок.
     *
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#group
     * @return {WebAccess.components.wrappers.toolBar.ToolBarGroup} Объект типа WebAccess.components.wrappers.toolBar.ToolBarGroup.
     * @deprecated since 5.6. Используйте метод getParentGroup.
     */
    group() {
      this._warnAboutDeprecatedMethod(arguments.callee.name);
      return this.getParentGroup();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    click(opt_callback) {
      if ($.isFunction(opt_callback)) {
        this.unbind("click");
      };
      this._super(opt_callback);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    bind(event, callback) {
      this._super(event, callback);
      if (this.isSynthetic && event == "click") { //Убираем алерт с подсказкой
        this._jObject.removeAttr("onclick"); // Здесь именно так 
        this._jObject.prop("onclick", null); // именно две строки
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Делает кнопку недоступной.
     * 
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#disable
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    */
    disable() {
      this._super();
      this._setActualHint();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Делает кнопку доступной.
     * 
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#enable
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    */
    enable() {
      this._super();
      this._setActualHint();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Устанавливает текст всплывающей подсказки.
     * 
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#setHints
     * @param {string} hint Текст всплывающей подсказки.
     * @param {string} disabledHint Текст всплывающей подсказки для недоступной кнопки.
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton} Объект типа ToolBarButton.
    */
    setHints(hint, disabledHint) {
      var me = this;
      me._hint = hint;
      me._disabledHint = disabledHint;
      me._setActualHint();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установить подсказку на основе состояния действия и значений свойств.
     *
     * @private
     * @method WebAccess.components.wrappers.toolBar.ToolBarButton#_setActualHint
     * @return {WebAccess.components.wrappers.toolBar.ToolBarButton}
    */
    _setActualHint() {
      var me = this;
      if (!me.isEnabled() && me._disabledHint) {
        me.setTooltip(me._disabledHint);
      } else {
        if (me._hint) {
          me.setTooltip(me._hint);
        } else {
          me.setTooltip(me.getLabel());
        }
      }
    }
  });

  global.components.wrappers.toolBar.ToolBarButton = ToolBarButton;
})(window.WebAccess);